"use strict";

angular.module("vendor")
.controller("SupplierEdit", function(
    $rootScope, $scope, $resource, $http, $window, $state, $stateParams, $timeout, appConfig, FlashBag, gettextCatalog,
    FormError, Language, PatternService, VendorTypesService, common, UserService, ModalService, StateExtensionService,
    EMAIL_MAXLENGTH, QUICKBOOKS
) {
    var _this = this;

    $scope.isQuickBooksGuide = $stateParams.qbo_guide || false;
    $scope.QuickBooksGuideURL = QUICKBOOKS.INTEGRATION_GUIDE_URL;

    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    var inventoryHolder = $resource(appConfig.API_SERVER + "/catalog/vendor/inventory-holder/");
    var quantityConstraintHolder = $resource(appConfig.API_SERVER + "/catalog/vendor/quantity-constraint-holder/");

    $scope.CompanyTypes = VendorTypesService.query();
    $scope.inventoryHolder = inventoryHolder.query();
    $scope.quantityConstraintHolder = quantityConstraintHolder.query();
    $scope.pattern = PatternService;
    $scope.isArray = angular.isArray;
    $scope.allowMarketManagement = null;
    $scope.marketManagement = {"zones": []};
    Language.initializeScope($scope, "language", "locale");

    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.allowMarketManagement = !!(user && user.vendor && user.vendor.allow_market_management);
    });

    this.validate = function() {
        FlashBag.clearAll();

        if (!$scope.Form) {
            return;
        }

        $scope.isFormSubmit = true;
        if (
            $scope.allowMarketManagement && $scope.Form.authorize_customer_request_partnership
            && this.hasMarketManagementErrors()
        ) {
            common.scrollTo("#market-targeting", -200);
            $("#market-targeting input").focus();
        }
        else if (!$scope.FormSupplierEdit.$valid) {
            FormError.focus("FormSupplierEdit");
        }
        else {
            this.validateZoneKey();
        }
    };

    this.hasMarketManagementErrors = function() {
        return $scope.isFormSubmit && ($scope.marketManagement.zones.isDirty || $scope.marketManagement.zones.length === 0)
    };

    this.fetch = function() {
        $http.get(appConfig.API_SERVER + "/auth/vendor/edit/").then(
            function onSuccess(response) {
                var data = response.data;
                $scope.Form = data;
                $scope.vendorId = data.id;
                $scope.User = {};
                $scope.User.CountryName = $scope.Form.address__CountryName;
                $scope.User.CountryCode = $scope.Form.address__CountryCode;
                $scope.User.ProvinceName = $scope.Form.address__ProvinceName;
                $scope.User.ProvinceCode = $scope.Form.address__ProvinceCode;
                $scope.User.Address = $scope.Form.address__Address;
                $scope.User.City = $scope.Form.address__City;
                $scope.User.PostalCode = $scope.Form.address__PostalCode;

                if ($scope.isQuickBooksGuide) {
                    $timeout(function() {
                        common.scrollTo("#quickbooks-integration");
                    }, 1000);
                }
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };

    this.fetch();

    this.validateZoneKey = function() {
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/market/zones/build/",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                city: $scope.User.City,
                province: $scope.User.ProvinceName,
                postalCode: $scope.User.PostalCode,
                countryName: $scope.User.CountryName
            })
        }).then(
            function success(resp) {
                if (resp.data.split(";").length >= 3) {
                    submit();
                }
                else {
                    FlashBag.preformattedError(gettextCatalog.getString("Your address is difficult to validate. Pay attention to the spelling with the displayed language or write us to support@wego.trade to assist you."), false);
                }
            },
            function failed(resp) {
                FlashBag.apiError(resp);
            }
        );
    };

    function submit() {
        $scope.Form.address__CountryName = $scope.User.CountryName;
        $scope.Form.address__CountryCode = $scope.User.CountryCode;
        $scope.Form.address__ProvinceName = $scope.User.ProvinceName;
        $scope.Form.address__ProvinceCode = $scope.User.ProvinceCode;
        $scope.Form.address__Address = $scope.User.Address;
        $scope.Form.address__City = $scope.User.City;
        $scope.Form.address__PostalCode = $scope.User.PostalCode;

        var fileNames = ["image_path"];
        var sendData = common.createFormDataFromFiles($scope.Form, fileNames);

        $http({
            url: appConfig.API_SERVER + "/auth/vendor/edit/",
            method: "POST",
            headers: {"Content-Type": undefined},
            data: sendData
        }).then(
            function success(response) {
                $scope.isSubmit = false;
                $scope.Form = response.data;
                FlashBag.success(gettextCatalog.getString("The company information was updated successfully."), true);
                UserService.refreshCurrentUser();
                if ($rootScope.fromState && $rootScope.fromState.name) {
                    $state.go($rootScope.fromState, $rootScope.fromParams || {});
                }
                else {
                    $state.go("home");
                }
            },
            function failed(response) {
                FlashBag.apiError(response);
            }
        );
    }

    if ($state.params.qbo_success) {
        FlashBag.success(gettextCatalog.getString("Your connection with QuickBooks was a success. Now you can contact Wegotrade to enabled the right QuickBooks available features."), true);
        StateExtensionService.updateUrlParams({qbo_success: undefined});
    }
    else if ($state.params.qbo_error) {
        FlashBag.error(gettextCatalog.getString("The connection to QuickBooks failed. Please retry later or contact Wegotrade."), true);
        StateExtensionService.updateUrlParams({qbo_error: undefined});
    }
    else if ($state.params.qbo_revoke) {
        FlashBag.success(gettextCatalog.getString("Your access to QuickBooks was revoked successfully."), true);
        StateExtensionService.updateUrlParams({qbo_revoke: undefined});
    }

    this.startQuickbooksAuthentication = function() {
        $window.location.href = appConfig.API_SERVER + "/quickbooks/authenticate/";
    };

    this.revokeQuickbooksAccess = function() {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("QuickBooks Revoke Access"),
                    message: gettextCatalog.getString("Do you want to revoke your access to QuickBooks?"),
                    confirmTextButton: gettextCatalog.getString("Revoke my Access"),
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return;
                }
                $http.post(appConfig.API_SERVER + "/quickbooks/vendor/revoke/").then(
                    function onSuccess() {
                        FlashBag.success(gettextCatalog.getString("Your access to QuickBooks was revoked successfully."), true);
                        _this.fetch();
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            });
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/auth/vendor.controller.js
// module id = 976
// module chunks = 0